import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Reviews from "@/components/Reviews";
import CTABanner from "@/components/CTABanner";
import PageHero from "@/components/PageHero";

export default function ReviewsPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="page-reviews" className="relative overflow-x-hidden">
      <Navbar />
      <PageHero
        breadcrumb={[{ label: t("common.company", "Company") }, { label: t("reviewsPage.breadcrumb", "Reviews") }]}
        pill={{ text: t("reviewsPage.pill", "Reviews") }}
        title={t("reviewsPage.titlePart1", "What clients say about")}
        accent={t("reviewsPage.titleAccent", "OFinancial Markets")}
        subline={t("reviewsPage.subline", "Verified client reviews from traders worldwide · share your own story and we'll publish it once we've reviewed it.")}
        primary={{ label: t("common.openAccount", "Open Account"),  to: "/account-comparison" }}
        secondary={{ label: t("reviewsPage.readFaq", "Read FAQ"), to: "/faq" }}
      />
      <main className="pb-20">
        <Reviews />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
